<div class="mat-modal-wrapper record-release-model">
	<app-ehe-verification-modal
		(action)="getAction($event)"
		[title]="'Share My Medical Records'"
		[button1]="'Submit'"
		[button2]="'Cancel'">
		<form [formGroup]="recordReleaseForm" class="record-release-form">
			<mat-error
				*ngIf="!isFormFieldsValid()"
				class="text-center mb-3"
				[translate]="'wellness.health-record.release-record.reviewEntries'">
				Please review your entries and resubmit.
			</mat-error>
			<!-- Patient Name Row -->
			<div class="field-group-row">
				<mat-form-field class="form-group" appearance="fill">
					<mat-label>Last Name</mat-label>
					<input matInput formControlName="patientLastName" placeholder="Last Name" />
					<mat-error>
						<app-error-message [control]="'patientLastName'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>First Name</mat-label>
					<input matInput formControlName="patientFirstName" placeholder="First Name" />
					<mat-error>
						<app-error-message [control]="'patientFirstName'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>Middle Name</mat-label>
					<input matInput formControlName="patientMiddleName" placeholder="Middle Name" />
				</mat-form-field>
			</div>

			<!-- DOB Row -->
			<div class="field-group-row">
				<app-dob
					floatLabel="always"
					[formGroup]="recordReleaseForm"
					control="patientDob"
					[invalidAge]="recordReleaseForm.get('dob')?.hasError('invalidAge')"
					[fieldLabel]="'Date of Birth*'"></app-dob>
				<mat-error>
					<div class="dob-error-message">
						<app-error-message control="patientDob"></app-error-message>
					</div>
				</mat-error>
			</div>

			<!-- Address Row -->
			<div class="field-group-row">
				<mat-form-field class="form-group" appearance="fill">
					<mat-label>Address</mat-label>
					<input matInput formControlName="patientAddress1" placeholder="Street Address" />
					<mat-error>
						<app-error-message [control]="'patientAddress1'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>Address Line 2</mat-label>
					<input matInput formControlName="patientAddress2" placeholder="Apt, Suite, Unit" />
				</mat-form-field>
			</div>

			<!-- City, State, Zip Row -->
			<div class="field-group-row">
				<mat-form-field class="form-group" appearance="fill">
					<mat-label>City</mat-label>
					<input matInput formControlName="patientCity" placeholder="City" />
					<mat-error>
						<app-error-message [control]="'patientCity'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>State</mat-label>
					<mat-select formControlName="patientState">
						<mat-option *ngFor="let state of states" [value]="state">
							{{ state }}
						</mat-option>
					</mat-select>
					<mat-error>
						<app-error-message [control]="'patientState'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>ZIP Code</mat-label>
					<input matInput formControlName="patientZipCode" placeholder="ZIP Code" maxlength="5" />
					<mat-error>
						<app-error-message [control]="'patientZipCode'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>

			<!-- Reports -->
			<div class="field-group-row">
				<mat-form-field class="form-group pl-0 pr-2" appearance="fill" [ngClass]="!isMobileView ? 'col-4' : ''">
					<mat-label>Report</mat-label>
					<mat-select formControlName="patientReportsList" multiple="true">
						<mat-option *ngFor="let report of reportTypes" [value]="report">
							{{ report }}
						</mat-option>
					</mat-select>
					<mat-error>
						<app-error-message [control]="'patientReportsList'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>

			<h6 class="sub-heading">Report Inclusions Opt-In*</h6>
			<p>
				The records/information that are/is disclosed will NOT contain sensitive information pertaining to
				alcohol/substance abuse, sexually transmitted illnesses, including HIV (Human Immunodeficiency Virus), mental
				health, or psychotherapy. If I would like that information disclosed, please select Yes:
			</p>
			<mat-radio-group formControlName="patientReportInclusionsOption" (change)="onInclusionOptionChange($event)">
				<mat-radio-button [value]="true">
					<span [translate]="'wellness.health-assessment-new.general-information.living-will.form-fields.option-yes'">
						Yes
					</span>
				</mat-radio-button>
				<mat-radio-button [value]="false">
					<span [translate]="'wellness.health-assessment-new.general-information.living-will.form-fields.option-no'">
						No
					</span>
				</mat-radio-button>
			</mat-radio-group>
			<mat-error>
				<app-error-message [control]="'patientReportInclusionsOption'"></app-error-message>
			</mat-error>

			<!-- Report Inclusions -->
			<h6 class="sub-heading">
				Report Inclusions
				<span *ngIf="recordReleaseForm.controls.patientReportInclusionsOption.value">*</span>
				<mat-error *ngIf="recordReleaseForm.controls.patientReportInclusionsList.errors">
					<app-error-message [control]="'patientReportInclusionsList'"></app-error-message>
				</mat-error>
			</h6>
			<div class="checkbox-container row">
				<div class="checkbox-list" *ngFor="let item of inclusionTypes" [ngClass]="!isMobileView ? 'col-6' : ''">
					<mat-checkbox (change)="inclusionSelection(item)" [checked]="">
						{{ item?.name }}
					</mat-checkbox>
				</div>
			</div>

			<h4 class="sub-heading">Provider Information</h4>
			<!-- Provider Name Row -->
			<div class="field-group-row">
				<mat-form-field class="form-group" appearance="fill">
					<mat-label>Last Name</mat-label>
					<input matInput formControlName="providerLastName" placeholder="Last Name" />
					<mat-error>
						<app-error-message [control]="'providerLastName'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>First Name</mat-label>
					<input matInput formControlName="providerFirstName" placeholder="First Name" />
					<mat-error>
						<app-error-message [control]="'providerFirstName'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>Middle Name</mat-label>
					<input matInput formControlName="providerMiddleName" placeholder="Middle Name" />
				</mat-form-field>
			</div>

			<!-- Provider Type Row -->
			<div class="field-group-row">
				<mat-form-field class="form-group" appearance="fill">
					<mat-label>Provider Type</mat-label>
					<input matInput formControlName="providerType" placeholder="Provider Type" />
					<mat-error>
						<app-error-message [control]="'providerType'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>

			<!-- Address Row -->
			<div class="field-group-row">
				<mat-form-field class="form-group" appearance="fill">
					<mat-label>Address</mat-label>
					<input matInput formControlName="providerAddress1" placeholder="Street Address" />
					<mat-error>
						<app-error-message [control]="'providerAddress1'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>Address Line 2</mat-label>
					<input matInput formControlName="providerAddress2" placeholder="Apt, Suite, Unit" />
				</mat-form-field>
			</div>

			<!-- City, State, Zip Row -->
			<div class="field-group-row">
				<mat-form-field class="form-group" appearance="fill">
					<mat-label>City</mat-label>
					<input matInput formControlName="providerCity" placeholder="City" />
					<mat-error>
						<app-error-message [control]="'providerCity'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>State</mat-label>
					<mat-select formControlName="providerState">
						<mat-option *ngFor="let state of states" [value]="state">
							{{ state }}
						</mat-option>
					</mat-select>
					<mat-error>
						<app-error-message [control]="'providerState'"></app-error-message>
					</mat-error>
				</mat-form-field>

				<mat-form-field class="form-group" appearance="fill">
					<mat-label>ZIP Code</mat-label>
					<input matInput formControlName="providerZipCode" placeholder="ZIP Code" maxlength="5" />
					<mat-error>
						<app-error-message [control]="'providerZipCode'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>

			<div class="field-group-row">
				<mat-form-field class="form-group pl-0 pr-2" appearance="fill" [ngClass]="!isMobileView ? 'col-4' : ''">
					<mat-label [translate]="'wellness.health-record.release-record.form-fields.phone'">Phone Number:</mat-label>
					<input matInput formControlName="providerPhoneNumber" />
					<mat-error>
						<app-error-message [control]="'providerPhoneNumber'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>

			<div class="field-group-row">
				<mat-form-field class="form-group pl-0 pr-2" appearance="fill" [ngClass]="!isMobileView ? 'col-4' : ''">
					<mat-label>How should your records be shared?</mat-label>
					<mat-select
						disableOptionCentering
						panelClass="custom-material-position"
						placeholder=""
						formControlName="recordSharingMethod"
						(selectionChange)="methodForSharing($event)"
						required>
						<mat-option *ngFor="let method of sharingMethods" [value]="method.id">
							<span>
								{{ method.name }}
							</span>
						</mat-option>
					</mat-select>
					<mat-error>
						<app-error-message [control]="'recordSharingMethod'"></app-error-message>
					</mat-error>
				</mat-form-field>
				<mat-form-field class="form-group" appearance="fill" *ngIf="showEmail">
					<mat-label [translate]="'wellness.health-record.release-record.form-fields.email'">Email:</mat-label>
					<input matInput formControlName="providerEmail" />
					<mat-error>
						<app-error-message [control]="'providerEmail'"></app-error-message>
					</mat-error>
				</mat-form-field>
				<mat-form-field class="form-group" appearance="fill" *ngIf="showFax">
					<mat-label [translate]="'wellness.health-record.release-record.form-fields.fax'">Fax:</mat-label>
					<input matInput formControlName="providerFaxNumber" />
					<mat-error>
						<app-error-message [control]="'providerFaxNumber'"></app-error-message>
					</mat-error>
				</mat-form-field>
				<mat-checkbox class="pt-3" (change)="setMailingAddress($event)" [checked]="" *ngIf="showMailingAdress">
					Same as provider address
				</mat-checkbox>
			</div>

			<ng-container *ngIf="showMailingAdress">
				<!-- Mailing Address Row -->
				<div class="field-group-row">
					<mat-form-field class="form-group" appearance="fill">
						<mat-label>Address</mat-label>
						<input matInput formControlName="mailingAddress1" placeholder="Street Address" />
						<mat-error>
							<app-error-message [control]="'mailingAddress1'"></app-error-message>
						</mat-error>
					</mat-form-field>

					<mat-form-field class="form-group" appearance="fill">
						<mat-label>Address Line 2</mat-label>
						<input matInput formControlName="mailingAddress2" placeholder="Apt, Suite, Unit" />
					</mat-form-field>
				</div>

				<!-- Mailing City, State, Zip Row -->
				<div class="field-group-row">
					<mat-form-field class="form-group" appearance="fill">
						<mat-label>City</mat-label>
						<input matInput formControlName="mailingCity" placeholder="City" />
						<mat-error>
							<app-error-message [control]="'mailingCity'"></app-error-message>
						</mat-error>
					</mat-form-field>

					<mat-form-field class="form-group" appearance="fill">
						<mat-label>State</mat-label>
						<mat-select formControlName="mailingState">
							<mat-option *ngFor="let state of states" [value]="state">
								{{ state }}
							</mat-option>
						</mat-select>
						<mat-error>
							<app-error-message [control]="'mailingState'"></app-error-message>
						</mat-error>
					</mat-form-field>

					<mat-form-field class="form-group" appearance="fill">
						<mat-label>ZIP Code</mat-label>
						<input matInput formControlName="mailingZipCode" placeholder="ZIP Code" maxlength="5" />
						<mat-error>
							<app-error-message [control]="'mailingZipCode'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</ng-container>

			<div class="field-group-row">
				<mat-form-field class="form-group pl-0 pr-2" appearance="fill" [ngClass]="!isMobileView ? 'col-4' : ''">
					<mat-label>Purpose of Authorization</mat-label>
					<mat-select
						disableOptionCentering
						panelClass="custom-material-position"
						placeholder=""
						formControlName="recordAuthorizationPurpose"
						(selectionChange)="onPurposeChange($event)"
						required>
						<mat-option *ngFor="let purpose of authorizationPurpose" [value]="purpose.id">
							<span>
								{{ purpose.name }}
							</span>
						</mat-option>
					</mat-select>
					<mat-error>
						<app-error-message [control]="'recordAuthorizationPurpose'"></app-error-message>
					</mat-error>
				</mat-form-field>
				<mat-form-field *ngIf="showOther" class="form-group" appearance="fill">
					<mat-label>Other Reason:</mat-label>
					<input matInput formControlName="recordAuthorizationPurposeOther" />
					<mat-error>
						<app-error-message [control]="'recordAuthorizationPurposeOther'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>
		</form>
		<div class="expiration">
			<h6>Expiration:</h6>
			<p>This authorization will expire in one year from the date signed.</p>
		</div>
		<div class="authorization mt-4">
			<h6>Authorization:</h6>
			<p>
				In accordance with applicable state law and the Health Insurance Portability and Accountability Act of 1996
				(HIPAA) and the Privacy Rule, I understand that the following apply:
			</p>
			<ul>
				<li>
					Voluntary. I understand and acknowledge that authorizing the disclosure of my medical records and health
					information is voluntary and I can refuse to sign this authorization. I understand that EHE Health may not
					condition treatment, payment, enrollment, or eligibility for benefits with EHE Health based on whether I sign
					this authorization or not. I further understand that I may inspect or obtain a copy of the information to be
					used or disclosed.
				</li>
				<li>
					Redisclosure. I understand and acknowledge that there is potential for the information that is used or
					disclosed pursuant to this authorization to redisclosure by the recipient which is no longer protected by
					federal or state privacy laws, including information related to alcohol/substance abuse, HIV, STIs (Sexually
					Transmitted Infections), mental health and psychotherapy.
				</li>
				<li>
					Revocation. I have the right to revoke this authorization at any time by providing a written request to
					<a href="mailto:MedicalRecords@ehe.health">MedicalRecords&#64;ehe.health</a>. I understand and acknowledge
					that if I choose to revoke this authorization, it will become effective on the date of the revocation and will
					not affect any previous action EHE Health took in reliance of the authorization prior to the revocation.
				</li>
			</ul>
		</div>
		<p class="disclaimer mt-5">
			<strong>
				By signing the below. I understand, acknowledge and agree that I am of legal age and I freely sign this
				authorization. I will receive a copy of this authorization once it is submitted electronically.
			</strong>
		</p>
		<div class="row">
			<app-signature-pad
				class="col-9"
				(signature)="getSignature($event)"
				[isSignatureMissingError]="isSignatureMissingError">
			</app-signature-pad>
			<div class="col-3 flex-inline">
				<h6 class="d-inline mr-1">Date:</h6>
				<span>{{ patientAuthorizationDate | date: 'MM/dd/yyyy' }}</span>
			</div>
		</div>
	</app-ehe-verification-modal>
</div>
